"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.find = exports.list = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.list = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ICD10_READ,
    method: 'get',
    path: 'icd10/list',
});
exports.find = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ICD10_READ,
    method: 'get',
    path: 'icd10/find',
});



//////////////////
// WEBPACK FOOTER
// ./src/api/icd10/icd10-client.ts
// module id = 986
// module chunks = 0 1 2